<template>
  <div>
    <!-- Start card profile -->
    <div class="col-12">
      <div class="row">
        <div class="col-12 pt-3 px-0">
          <h3 class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold">
            Mensualidades
          </h3>
          <div class="row">
            <div class="form-group col-12 col-md-8 mb-0 mb-md-4 px-0">
              <div class="row mr-2">
                <div class="col-12 col-lg-4 px-0">
                  <label for="">Búsqueda</label>
                  <input
                    type="text"
                    placeholder="Buscar"
                    class="form-control form-control-sm mt-1 mb-2"
                    v-model="searchQuery"
                    style="height: 42px"
                    @input="loadElements()"
                  />
                </div>
                <div class="col-12 col-lg-4 mt-1 pl-0 pl-lg-3 pr-0 div-select">
                  <label for="">Modo</label>
                  <Multiselect
                    v-model="selectedTypePaymentMode"
                    :options="typePaymentModes"
                    label="name"
                    placeholder="Modo"
                    :show-labels="false"
                    id="typeStatus"
                    @input="loadElements()"
                  ></Multiselect>
                </div>
                <button
                  class="btn px-2 d-flex align-items-center border-primary align-self-end ml-lg-2 mt-lg-0 mt-2 mb-2"
                  style="height: 42px"
                  @click="resetQuery()"
                >
                  <i class="bi bi-eraser-fill text-primary"></i>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 p-0 mb-3 pt-md-4 pl-md-0">
              <div
                class="d-flex justify-content-md-center pt-2"
                style="gap: 5px"
              >
                <button
                  v-if="false"
                  type="button"
                  class="col-6 text-white mb-0 mt-md-0 mt-2 bg-primary border-0 mr-0 btn"
                  @click="goNewPayment"
                >
                  Crear Pago
                </button>
                <button
                  type="button"
                  class="col-6 text-white mb-0 mt-md-0 mt-2 bg-primary border-0 ml-0 btn"
                  @click="goNewCollection"
                >
                  Crear Cobro
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive card">
            <table class="table table-sm table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Orden</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Id</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">
                      Fecha de Cobro
                    </div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Título</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Modo de pago</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Empresa</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Delivery</div>
                  </th>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">IVA</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Monto</div>
                  </th>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Acciones</div>
                  </th>
                  <th class="d-none"></th>
                </tr>
              </thead>
              <tbody class=" ">
                <tr class="" v-for="item in payment_fees" :key="item.id">
                  <td class="text-center">
                    <span
                      class="rounded-lg w-100 py-1 d-flex justify-content-center text-white"
                      style="background-color: #1863e573"
                      >{{ item.order }}</span
                    >
                  </td>
                  <td class="text-center">
                    {{ item.id }}
                  </td>
                  <td class="text-center">
                    {{
                      item.created_at
                        .split(' ')[0]
                        .split('-')
                        .reverse()
                        .join('/')
                    }}
                  </td>
                  <td class="text-center">{{ item.title }}</td>
                  <td class="text-center">
                    {{
                      item.id_type_payment_mode === 1 ? 'Global' : 'Individual'
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      item.id_type_company
                        ? item.id_type_company === 1
                          ? 'Indefinida'
                          : item.id_type_company === 2
                          ? 'Pequeña'
                          : item.id_type_company === 3
                          ? 'Mediana'
                          : 'Grande'
                        : item.company.company_name
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      item.type_service
                        ? item.type_service.name
                        : 'Sin Delivery'
                    }}
                  </td>
                  <td class="text-center">
                    {{ item.has_iva === 1 ? 'Si' : 'No' }}
                  </td>
                  <td class="text-center">
                    <span
                      v-if="
                        item.type_currency &&
                        item.type_currency.name === 'Dolar'
                      "
                      >$</span
                    >
                    <span
                      v-else-if="
                        item.type_currency && item.type_currency.name === 'Euro'
                      "
                      >€</span
                    >
                    <span
                      v-else-if="
                        item.type_currency &&
                        item.type_currency.name === 'Bolivares'
                      "
                      >Bs.</span
                    >
                    <span v-else></span>
                    {{ item.expected_amount }}
                    
                  </td>

                  <td class="text-center">
                    <div class="d-flex justify-content-center w-100">
                      <Tooltip text="Eliminar">
                        <button
                          class="btn bg-danger d-flex justify-content-center align-items-center border-0 ml-1 p-2"
                          @click="goDelete(item.id)"
                        >
                          <i
                            class="bi bi-trash text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                    </div>
                  </td>

                  <td class="d-none"></td>
                </tr>
              </tbody>
            </table>
            <!--Paginacion-->
            <!--Paginacion-->
            <div class="d-flex justify-content-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage - 1)"
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item" v-for="page in totalPages" :key="page">
                    <a
                      class="page-link"
                      :class="{
                        'bg-primary ': page == currentPage,
                        'text-white': page === currentPage
                      }"
                      href="#"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage + 1)"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      buttonNewCollectionUrl: 'NewCollection',
      buttonNewPaymentUrl: 'NewMonthlyPaymentRecived',
      buttonEditUrl: 'EditCollection',
      payment_fees: [],
      searchQuery: '',
      currentPage: 1,
      totalPages: 0,
      limit: 10,
      selectedTypePaymentMode: '',
      typePaymentModes: []
    }
  },
  methods: {
    ...mapActions(['getData', 'updateData', 'changeStatusData']),
    resetQuery() {
      this.selectedTypePaymentMode = ''
      this.searchQuery = ''
      this.loadElements(1, this.id_user_balance)
    },
    goDelete(id) {
      // Confirmación antes de guardar
      Swal.fire({
        title: '¡Atención!',
        text: 'Esta acción eliminará el cobro masivo generado y todos los pagos pendientes de las empresas, realice esta acción solo si esta totalmente seguro, debe generar nuevamente los cobros.',
        icon: 'question',
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, eliminar'
      }).then((result) => {
        if (result.isConfirmed) {
          const form = {
            url: 'payment_fee/delete',
            id: id,
            data: {
              id_payment_fee: id
            }
          }

          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Cobros y pagos pendientes eliminados correctamente',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000
                })

                this.loadElements(1, this.id_user_balance)
              } else if (response.code === 409) {
                Swal.fire({
                  title: 'Error',
                  text: 'Ya existe un cobro con ese título.',
                  icon: 'error',

                  confirmButtonText: 'Aceptar'
                })
                this.loadElements(1, this.id_user_balance)
              }
            })
            .catch((error) => {
              console.log(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',

                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },
    loadTypePaymentModes() {
      const form = {
        url: 'type_payment_mode/all',
        params: {
          active: 1
        }
      }
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typePaymentModes = [
              { value: '', name: 'Todos' },
              ...response.data.map((item) => ({
                value: item.id,
                name: item.name
              }))
            ]
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadElements(page = 1) {
      const form = {
        url: 'payment_fee/all',
        params: {
          query: this.searchQuery,
          id_type_payment_mode: this.selectedTypePaymentMode.value,
          order_key: 'id',
          order_value: 'desc',
          page: page,
          limit: this.limit
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.payment_fees = response.data.data
            const startOrder = (page - 1) * this.limit + 1
            this.payment_fees = response.data.data.map(
              (payment_fee, index) => ({
                ...payment_fee,
                order: startOrder + index
              })
            )
            this.currentPage = response.data.meta.current_page
            this.totalPages = response.data.meta.last_page
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.loadElements(page)
    },
    goNewCollection() {
      this.$router.push({ name: this.buttonNewCollectionUrl })
    },
    goNewPayment() {
      this.$router.push({ name: this.buttonNewPaymentUrl })
    },
    goEdit(id) {
      this.$router.push({ name: this.buttonEditUrl, params: { id: id } })
    }
  },
  mounted() {
    this.loadElements()
    this.loadTypePaymentModes()
  }
}
</script>

<style>
tr:last-child td {
  border-bottom: 1px solid #dee2e6; /* Asegúrate de que la última fila tenga un borde inferior */
}
/**Style Select */
.div-select {
  margin-top: 33px;
}

.btn-create {
  width: 150px;
  border-radius: 20px;
}
</style>
